import { Canvas, useFrame } from "@react-three/fiber";
import { Float, Environment } from "@react-three/drei";
import { useRef } from "react";
import * as THREE from "three";

function scrollProgress() {
  const max = document.documentElement.scrollHeight - window.innerHeight;
  return max > 0 ? window.scrollY / max : 0;
}

const ORBS = [
  { pos: [-3.6, 1.7, -1], scale: 1.15, color: "#C9CBF5" },
  { pos: [3.8, 2.1, -2], scale: 1.7, color: "#E9D9C6" },
  { pos: [3.1, -2.3, -1.5], scale: 1.0, color: "#F1EEE7" },
  { pos: [-3.9, -1.9, -2.5], scale: 1.35, color: "#D9D2F0" },
  { pos: [0.4, 3.0, -3], scale: 0.8, color: "#EADFCE" },
  { pos: [-1.2, -2.9, -3.2], scale: 0.9, color: "#DCE0F2" },
];

function Orb({ pos, scale, color, i }) {
  const ref = useRef();
  useFrame((state) => {
    const p = scrollProgress();
    if (!ref.current) return;
    const drift = pos[1] - p * (3 + i * 0.4);
    ref.current.position.y = THREE.MathUtils.lerp(ref.current.position.y, drift + state.pointer.y * 0.3, 0.05);
    ref.current.position.x = THREE.MathUtils.lerp(ref.current.position.x, pos[0] + state.pointer.x * 0.35, 0.05);
  });
  return (
    <Float speed={1.1} rotationIntensity={0.3} floatIntensity={1.6}>
      <mesh ref={ref} position={pos} scale={scale}>
        <sphereGeometry args={[1, 64, 64]} />
        <meshStandardMaterial color={color} roughness={0.42} metalness={0.15} envMapIntensity={0.7} />
      </mesh>
    </Float>
  );
}

export default function Scene() {
  return (
    <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true">
      <Canvas dpr={[1, 1.6]} camera={{ position: [0, 0, 8], fov: 42 }} gl={{ alpha: true, antialias: true }}>
        <ambientLight intensity={0.8} />
        <directionalLight position={[4, 6, 5]} intensity={1.4} color="#ffffff" />
        <directionalLight position={[-5, -2, -3]} intensity={0.5} color="#c9cbf5" />
        {ORBS.map((o, i) => (
          <Orb key={i} i={i} {...o} />
        ))}
        <Environment preset="apartment" environmentIntensity={0.6} />
      </Canvas>
    </div>
  );
}
